// extracted by mini-css-extract-plugin
export default {"element":"style_element__tAreD","image":"style_image__jujQu","animating":"style_animating__uRIwt","static":"style_static__v103b","touch":"style_touch__ZvM0r"};